import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import classNames from 'classnames';

import { Chip, ChipSizeMD, ChipSizeXL } from '@picsart/design-system/components/Chip';

import { useTranslator } from '@picsart/rc/services/localization';
import deviceType from 'hooks/useDeviceType';
import { LandingsType } from '../types';
import useStyles from './styles';
import { DEFAULT_PATH } from '../constants';

const CategoryList = ({
  landings,
  pagePath,
}: {
  landings: LandingsType[];
  pagePath: string | undefined;
}) => {
  const styles = useStyles();
  const [selectedCategory, setSelectCategory] = useState<string | undefined>();
  const translate = useTranslator();
  const navigate = useNavigate();
  const { isMobile } = deviceType();

  useEffect(() => {
    setSelectCategory(pagePath ? `fonts/${pagePath}` : 'all');
  }, [pagePath]);

  const handleChipClick = useCallback(
    (slug: string) => {
      if (slug === 'all') {
        setSelectCategory(slug);
        navigate(`/${DEFAULT_PATH}/`);
      } else {
        const landing = landings.find(item => item.slug === slug);
        setSelectCategory(landing?.slug);
        navigate(`/${slug}/`);
      }
    },
    [landings, navigate],
  );
  return (
    <div className={styles.root} data-testid="category-list">
      <div className={styles.categories}>
        <Chip
          text={translate('All')}
          onClick={() => handleChipClick('all')}
          className={classNames(styles.chip, {
            [styles.selectedChip]: selectedCategory === 'all',
          })}
          size={isMobile ? ChipSizeMD : ChipSizeXL}
        />
        {Array.isArray(landings) &&
          landings.map((landing: LandingsType) => (
            <Chip
              key={landing.id}
              size={isMobile ? ChipSizeMD : ChipSizeXL}
              text={landing.name}
              onClick={() => handleChipClick(landing.slug)}
              className={classNames(styles.chip, {
                [styles.selectedChip]: selectedCategory === landing.slug,
              })}
            />
          ))}
      </div>
    </div>
  );
};

export default CategoryList;
